import React, { useState, Component } from 'react';
import { Calculator, MessageCircle } from 'lucide-react';
import { motion } from 'framer-motion';
export function Simulator() {
  const [amount, setAmount] = useState('');
  const handleWhatsApp = () => {
    const text = `Hola, tengo aproximadamente USD ${amount || '...'} y quisiera cotizar estos billetes. Adjunto fotos.`;
    window.open(`https://wa.me/5491176110902?text=${encodeURIComponent(text)}`, '_blank');
  };
  return <section className="py-20 bg-slate-50 relative overflow-hidden border-t border-slate-200" data-id="element-145">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-blue-100/50 via-slate-50 to-slate-50" data-id="element-146"></div>

      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-147">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-white border border-slate-200 rounded-3xl p-8 md:p-12 shadow-xl" data-id="element-148">
          <div className="flex items-center gap-3 mb-8 justify-center" data-id="element-149">
            <Calculator className="w-8 h-8 text-blue-700" data-id="element-150" />
            <h2 className="text-2xl md:text-3xl font-bold text-[#0a2540]" data-id="element-151">
              Cotizador Rápido
            </h2>
          </div>

          <div className="space-y-6" data-id="element-152">
            <div data-id="element-153">
              <label htmlFor="amount" className="block text-sm font-medium text-slate-600 mb-2" data-id="element-154">
                Cantidad aproximada (USD)
              </label>
              <div className="relative" data-id="element-155">
                <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none" data-id="element-156">
                  <span className="text-slate-400 font-medium" data-id="element-157">$</span>
                </div>
                <input type="number" id="amount" value={amount} onChange={e => setAmount(e.target.value)} className="block w-full pl-8 pr-4 py-4 bg-slate-50 border border-slate-300 rounded-xl text-[#0a2540] placeholder-slate-400 focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all text-lg" placeholder="Ej: 500" data-id="element-158" />
              </div>
            </div>

            <button onClick={handleWhatsApp} className="w-full flex items-center justify-center gap-2 bg-[#0a2540] hover:bg-[#1a365d] text-white font-bold py-4 px-8 rounded-xl transition-all duration-300 transform hover:scale-[1.02] active:scale-[0.98] shadow-md" data-id="element-159">
              <MessageCircle className="w-5 h-5" data-id="element-160" />
              Cotizar por WhatsApp
            </button>
            <p className="text-center text-xs text-slate-500 mt-4" data-id="element-161">
              La cotización final dependerá del estado de los billetes.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}